<!-- Responsibility: Implement about dialog behavior for the ui/dialog surface.
Scope: Owns ui/dialog concerns only; cross-surface orchestration is excluded. -->
<about-dialog class="about-body">
  <header class="about-header">
    <div>
      <h2>AnyQuest (tm)</h2>
      <small>The adventure machine and world weaver you dreamed about.</small>
    </div>
    <button class="close-btn modal-close-hit" aria-label="Close about dialog" onclick={ closeDialog }>X</button>
  </header>
  
  <p>AnyQuest is a machine for creating and playing dynamically generated, infinite RPG powered by cutting-edge Large Language Models.
    Every world you explore, companion you meet, and action you take is uniquely forged in real-time
    and have consequences.</p>
  <p>
    This is an Alpha Stage product.
  </p>
  
  <section>
    <p><strong>Created by:</strong> Dharmax and AI friends</p>
  </section>

  <section>
    <h3>LINKS & SUPPORT</h3>
    <a href="mailto:dharmax@gmail.com" target="_blank" rel="noopener">Contact Creator</a>
     - or, use the "feedback" button on the screen, at any time.
  </section>

  <script>
    export default {
      async closeDialog() {
        await this.props.requestModalClose?.('close-button')
      },
    }
  </script>

  <style>
    about-dialog {
      display: block;
      text-align: center;
      padding-top: var(--space-xs);

      > .about-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--space-md);
      }

      > .about-header h2 {
        color: var(--gold);
        margin: var(--space-xs) 0 var(--space-xs);
        font-size: var(--type-lg);
        letter-spacing: 0.1em;
      }

      > .version {
        color: var(--text-dim);
        font-size: var(--type-xs);
        letter-spacing: 0.15em;
        margin-bottom: var(--space-lg);
      }

      > p {
        color: var(--text-prose);
        line-height: 1.6;
        font-size: var(--type-sm);
        margin-bottom: var(--space-lg);
        text-align: left;
      }

      > section {
        text-align: left;
        margin-top: var(--space-lg);
        padding-top: var(--space-md);
        border-top: 1px solid color-mix(in srgb, var(--border) 40%, transparent);

        > h3 {
          font-size: var(--type-2xs);
          color: var(--text-dim);
          letter-spacing: 0.15em;
          margin: 0 0 var(--space-sm);
          text-transform: uppercase;
        }

        > p {
          margin: 0 0 var(--space-xs);
          font-size: var(--type-sm);

          > strong {
            color: var(--text-muted);
          }
        }

        > a {
          display: block;
          color: var(--brand-primary);
          text-decoration: none;
          padding: var(--space-sm);
          background: color-mix(in srgb, var(--bg) 60%, transparent);
          border: 1px solid color-mix(in srgb, var(--border) 40%, transparent);
          border-radius: var(--space-xs);
          margin-bottom: var(--space-xs);
          font-size: var(--type-sm);
          transition: background var(--motion-fast) ease, transform var(--motion-fast) ease;

          &:hover {
            background: color-mix(in srgb, var(--bg) var(--alpha-high), transparent);
            border-color: var(--brand-primary);
            transform: translateX(0.125rem);
          }
        }
      }
    }
  </style>
</about-dialog>
